import script from "./material.vue?vue&type=script&setup=true&lang=js"
export * from "./material.vue?vue&type=script&setup=true&lang=js"

import "./material.vue?vue&type=style&index=0&id=4f01de64&lang=scss&scoped=true"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f01de64"]])

export default __exports__